import Toggle from "../../components/Toggle/Toggle";
import { FaPen ,FaTrashAlt } from 'react-icons/fa';
import { SlCalender } from "react-icons/sl";
import m from "../../utils/date"

export const columns = (openModal, promptDeleteContract, openFileModal, update) => [
  { header: '수주일', accessor: 'contractDt' },
  { header: '거래처명', accessor: 'partnerName' },
  { header: '수주번호', accessor: 'contractNum' },
  { header: '제품명', accessor: 'productName' },
  { header: '규격', accessor: 'specification' },
  { header: '제품 코드', accessor: 'productCode' },
  { header: '납기일', accessor: 'dueDt' },
  { header: '완료일', accessor: 'completeDt', 
    render: (row) => row.completeDt != null ? `${ row.completeDt }` : 
    <span onClick={() => {}} style={{ cursor: 'pointer' }}>
      {/* <SlCalender/> */}
      -
    </span>
  },
  { header: '출고일', accessor: 'releaseDt', 
    render: (row) => row.releaseDt != '' ? `${ row.releaseDt }` : 
    <span onClick={() => {}} style={{ cursor: 'pointer' }}>-</span>
  },
  { header: '발주 수량', accessor: 'quantity' },
  { header: '수주액', accessor: 'price', render: (row) => `${(row.price ?? 0).toLocaleString()} 원` },
  { header: '단가', accessor: 'unitPrice', render: (row) => `${(row.unitPrice ?? 0).toLocaleString()} 원` },
  { header: '합계', accessor: 'sumPrice', render: (row) => `${(row.sumPrice ?? 0).toLocaleString()} 원` },
  { header: '세액', accessor: 'tax', render: (row) => `${(row.tax ?? 0).toLocaleString()} 원` },
  { header: '총계', accessor: 'totalPrice', render: (row) => `${(row.totalPrice ?? 0).toLocaleString()} 원` },
  { header: '현장지시', accessor: 'confirm', sortable: false, render: (row) => (
      <Toggle
        isOn={ row.confirm }
        handleToggle={(e)=>{ e.stopPropagation(); update({contractSeq : row.contractSeq, confirm : !row.confirm}, 1)}}
        onText="확정"
        offText="미확정"
      />
    )
  },
  { header: '첨부파일', accessor: 'attachments', sortable: false, render: (row) => <span onClick={(e) => {e.stopPropagation(); openFileModal(row); }}>📎</span> },
  { header: '수정', accessor: 'update', sortable: false, render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal(2, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', sortable: false, render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); promptDeleteContract(row, 1)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const formFields = [
  { key: "contractSeq", label: "수주번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "productSeq", label: "제품", type: "apiSelect", apiKey: 'product', labelKey: "productName", valueKey: "productSeq", size: 6, visible: true, required: true },
  { key: "partnerSeq", label: "거래처", type: "apiSelect", apiKey: 'partner',  labelKey: "partnerName", valueKey: "partnerSeq", size: 6, visible: true, required: true }, 
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: 'user',  labelKey: "userName", valueKey: "userSeq", size: 6, visible: false, required: false },
  { key: "contractNum", label: "수주번호", type: "text", size: 6, visible: true, required: false },
  { key: "quantity", label: "발주 수량", type: "number", size: 6, visible: true, required: true },
  { key: "unitPrice", label: "단가", type: "number", size: 6, visible: true, required: false },
  {
    key: "price", label: "수주액", type: "number", size: 6, visible: true, required: true,
    compute: { from: ['unitPrice', 'quantity'], calc: ({ unitPrice, quantity }) => (Number(unitPrice) || 0) * (Number(quantity) || 0) },
  },
  { key: "contractDt", label: "수주일", type: "date", size: 6, visible: true, required: false},
  { key: "dueDt", label: "납기일", type: "date", size: 6, visible: true, required: true },
  { key: "completeDt", label: "완료일", type: "date", size: 6, visible: true, required: false },
  { key: "releaseDt", label: "출고일", type: "date", size: 6, visible: true, required: false },
  { key: "confirm", label: "확정지시", type: "checkbox", onText: "확정", offText: "미확정", size: 6, visible: true, required: false, default: false },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false }
];

export const searchFormFields = [
  { key: "dateType", label: "날짜 검색", type: "dateRangeSelect", visible: true, required: false,
    dateOptions: [
      { label: "수주일", value: "contractDt", startKey: "contractStartDt", endKey: "contractEndDt" },
      { label: "납기일", value: "dueDt", startKey: "dueStartDt", endKey: "dueEndDt" },
      { label: "완료일", value: "completeDt", startKey: "completeStartDt", endKey: "completeEndDt" },
      { label: "출고일", value: "releaseDt", startKey: "releaseStartDt", endKey: "releaseEndDt" },
    ]
  },

  { key: "partnerSeq", label: "거래처", type: "apiSelect", apiKey: 'partner',  labelKey: "partnerName", valueKey: "partnerSeq", size: 6, visible: true, required: false },
  { key: "productSeq", label: "제품명", type: "apiSelect", apiKey: 'product', labelKey: "productName", valueKey: "productSeq", size: 6, visible: true, required: false },


  { key: "contractNum", label: "수주번호", type: "text", size: 6, visible: true, required: false },
];